import React from 'react';
import axios from 'axios';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Pagination from '../Pagination';
import { Link, Redirect } from 'react-router-dom';
import PagerService from '../Services/PagerService';
import { connect } from 'react-redux';
import environment from '../environments/environment';
import { toast, ToastContainer } from 'react-toastify';
import CancelModalComponent from '../popUpModals/CancelModalComponent';
import AuthService from '../Services/AuthService'
import * as MicrosoftGraphClient from "@microsoft/microsoft-graph-client";
import * as constants from '../Constants';
import { Loading } from 'react-loading-ui';

const mapStateToProps = (state) => {
    return {
        userStatus: state.lognReducer
    }
}

class NewUser extends React.Component {
    constructor() {
        super();
        this.state = {
            show: false,
            usersList: [],
            reDirect: '',
            pageSize: '',
            totalItems: '',
            //pager object
            pager: {},
            // paged items
            pagedItems: [],
            email: '',
            userRole: '',
            accessToken: '',
            name: '',
            userID: '',
            errorMessage: ''
        }
    }

    componentDidMount = async () => {
        if (this.props.userStatus.userName !== "") {
            this.setState({
                ...this.state,
                pageSize: this.toSetPagination(),
                email: this.props.userStatus.emailId,
                userRole: this.props.userStatus.userRole,
                accessToken: this.props.userStatus.accessToken,
            }, () => {
                this.setPage(1);
            })

        } else {
            this.setState({
                reDirect: '/',
            })
        }
    }

    changeValue = (e) => {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value });
    }

    search = e => {
        e.preventDefault();
        this.setPage(1);
    }

    clear = e => {
        e.preventDefault();
        this.setState({
            name: '',
            userID: ''
        }, () => {
            this.setPage(1);
        })
    }
    toSetPagination() {
        let pageSize = 0;
        if (localStorage.getItem("listingPageSize") != null &&
            localStorage.getItem("listingPageSize") !== undefined && localStorage.getItem("listingPageSize") !== '0') {
            let tempstr = localStorage.getItem("listingPageSize");
            pageSize = parseInt(tempstr);
        }
        else {
            pageSize = 5;
        }
        return pageSize;
    }

    onPageNoChanged = (pageNo) => {
        this.setPage(pageNo);
    }

    pageSizeChanged = (pageSize) => {
        this.setState({
            pageSize: pageSize
        }, () => {
            this.setPage(1);
            localStorage.setItem('listingPageSize', pageSize);
        })
    }

    setPage(page) {
        Loading();

        if (AuthService.isLoggedIn()) {

            this.msGraphClient = MicrosoftGraphClient.Client.init({
                authProvider: async (done) => {
                    if (!this.state.accessToken.accessToken) {
                        // Might redirect the browser and not return; will redirect back if successful
                        const token = await AuthService.getRefreshAccessToken(["User.Read", "Mail.Read", "offline_access"]);
                        this.setState({
                            accessToken: token
                        });
                    }
                    done(null, this.state.accessToken);
                }
            });

            this.msGraphClient
                .api('groups/'+environment.azureGroupId+'/members')
                .select('displayName,givenName,mail,surname')
                .top(999).get(async (error, azureUsers, rawResponse) => {
                    if (azureUsers != null) {
                        this.getAllUsers(page, this.state.pageSize, azureUsers);
                        setTimeout(() => {
                            Loading();
                        });
                    }
                });
        }
    }

    getAllUsers(page, pazeSize, azureUsers) {
        let azureGroupUsers = {}
        azureGroupUsers.userName = this.state.userID;
        azureGroupUsers.name = this.state.name;
        azureGroupUsers.azureUsersList = [];

        let aUsersList = [];
        for (let i = 0; i < azureUsers.value.length; i++) {
            let azureUser = {};
            azureUser.displayName = azureUsers.value[i].displayName;
            azureUser.givenName = azureUsers.value[i].givenName;
            azureUser.mail = azureUsers.value[i].mail;
            azureUser.surname = azureUsers.value[i].surname;
            aUsersList.push(azureUser);

        }
        azureGroupUsers.azureUsersList = aUsersList;
        axios.post(environment.getAllUsers, azureGroupUsers)
            .then(response => {
                if (response !== undefined && response !== null && response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                    if (response.data.azurUserVOList !== undefined && response.data.azurUserVOList !== null
                        && response.data.azurUserVOList.length !== 0) {
                        this.setState({
                            usersList: response.data.azurUserVOList,
                            userscount: response.data.azurUserVOList.length
                        }, () => {
                            this.setCheckBox();
                            this.setState({
                                pageSize: this.toSetPagination(),
                                pager: PagerService.getPager(
                                    this.state.userscount,
                                    page,
                                    this.state.pageSize
                                ),
                                totalItems: this.state.userscount,
                            }, () => {
                                this.setState({
                                    ...this.state,
                                    pagedItems: this.state.usersList.slice(
                                        this.state.pager.startIndex,
                                        this.state.pager.endIndex + 1
                                    )
                                })
                            });
                        })
                    } else {
                        this.setState({
                            ...this.state,
                            totalItems: 0,
                            pagedItems: []
                        })
                    }
                } else {
                    toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER });
                    this.setState({
                        ...this.state,
                        totalItems: 0,
                        pagedItems: []
                    })
                }
            }).catch((error) => {
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER });
            });
    }

    setCheckBox() {
        if (this.props.values.UsersList !== undefined && this.props.values.UsersList !== null && this.props.values.UsersList.length > 0) {
            let newUserList = this.state.usersList;
            for (let i = 0; i < newUserList.length; i++) {
                for (let j = 0; j < this.props.values.UsersList.length; j++) {
                    if (newUserList[i].mailId === this.props.values.UsersList[j].mailId) {
                        newUserList[i].selected = true;
                    }
                }
            }
            this.setState({
                ...this.state,
                usersList: newUserList
            });

        } else {
            this.setState({
                ...this.state,
                usersList: this.state.usersList.map(
                    (obj, i) => Object.assign(obj, { selected: false })
                )
            });
        }

    }

    onCancelChanges() {
        this.setState({
            reDirect: './userSummary'
        })
    }

    toContinue(event) {
        event.preventDefault();
        if (this.props.values.UsersList !== undefined && this.props.values.UsersList !== null && this.props.values.UsersList.length > 0) {
            this.props.nextStep();
        } else {
            this.setState({
                errorMessage: "Please select atleast one user"
            })
        }
    }

    toBack(event) {
        event.preventDefault();
        this.setState({
            reDirect: './userSummary'
        })
    }

    onUserSelected(event, user) {
        this.setState({
            ...this.state,
            usersList: this.state.usersList.map(
                userRec => userRec.mailId === user.mailId ? Object.assign(userRec, { selected: event.target.checked }) : userRec
            ),
            errorMessage: ''
        }, () => {
            this.props.handleChanges(user, event.target.checked);
        });
    }

    showModal = (event) => {
        event.preventDefault();
        this.setState({
            ...this.state,
            show: true
        })
    }

    onCloseModal() {
        this.setState({
            show: false
        })
    }

    render() {
        if (this.state.reDirect) {
            return <Redirect
                to={{
                    pathname: this.state.reDirect
                }} />
        }
        return (
            <section style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                <div className="container mt-2 ">
                    <h4>Select User</h4>
                    <div className="row mb15 mr-2" style={{ marginTop: ' 15px' }}>
                        <div className="col-3 pl-0 pr-0">
                            <label className="col  "> Name</label>&nbsp;
                            <input type="text" id="name" name="name" placeholder="Name" value={this.state.name} onChange={this.changeValue}></input>
                        </div>
                        {/* <div className="col pl-0 pr-0">
                            <label className="col  ">Last Name</label>&nbsp;
                            <input  type="text" id="LastName" name="LastName" placeholder="Last Name" value={this.state.LastName} onChange={this.changeValue}></input>
                       
                        </div>  */}
                        <div className="col-3 pl-0 pr-0">
                            <label className="col  ">Login Id</label>&nbsp;
                            <input type="text" id="userID" name="userID" placeholder="E-mail" value={this.state.userID} onChange={this.changeValue}></input>
                        </div>
                    </div>

                    <div className="row mb-2 mt-2">
                        <div className="col-md-6 mr-auto text-left">
                            <Link onClick={this.search}><span
                                className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Search</span></Link>
                            <Link onClick={this.clear}><span
                                className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Clear</span> </Link>

                        </div>
                    </div >

                    <div className="table-responsive dashboard ">
                        <table className="table table-bordered table-condensed table-striped table-hover table-sm"
                            id="table-dashboard">

                            <thead className="color">
                                <tr style={{ borderStyle: 'hidden' }}>
                                    <th></th>
                                    <th > Name </th>
                                    <th >Login Id</th>
                                    <th >User Type</th>
                                    <th >Source</th>

                                </tr>
                            </thead>
                            <tbody style={{ borderStyle: 'hidden' }}  >
                                {this.state.pagedItems.map((user, index) => (
                                    user.isExist === constants.IS_ACTIVE_NO && <tr key={index}>
                                        <td align="center">{user.selected ?
                                            (<input type="checkbox" name="user"
                                                onChange={(event) => { this.onUserSelected(event, user) }} checked
                                            ></input>) : (<input type="checkbox" name="user" onChange={(event) => { this.onUserSelected(event, user) }}
                                            ></input>)}
                                        </td>
                                        <td>{user.displayName}</td>
                                        <td>{user.mailId}</td>
                                        <td>Member</td>
                                        <td>Azure Active Directory</td>
                                    </tr>
                                ))}
                            </tbody>

                        </table>
                    </div>
                    <p className='text-danger'>{this.state.errorMessage}</p>
                    {this.state.totalItems === 0 && <p> No Records are Found.</p>}
                    {this.state.pagedItems !== undefined && this.state.totalItems > 5 && <Pagination pager={this.state.pager} setPage={this.onPageNoChanged} setPageSize={this.pageSizeChanged}></Pagination>}
                    <main>
                        <div className="row mb-2 mt-2">
                            <div className="col-md-6 mr-auto text-left">
                                <button className="btn  btn-primary" onClick={(event) => this.toBack(event)} style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Back</button>
                                <button className="btn  btn-primary" onClick={(event) => this.toContinue(event)} style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Continue</button>
                                <button type="button" onClick={this.showModal} className="btn  btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Cancel  </button>
                            </div>
                        </div >
                        <CancelModalComponent show={this.state.show} hideModal={() => this.onCloseModal()} cancelChanges={() => this.onCancelChanges()}></CancelModalComponent>
                    </main>
                </div >
                <ToastContainer style={{ marginTop: '7%' }} />
            </section >
        )
    }

}
export default connect(mapStateToProps)(NewUser);